/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Bond product subscription type
 */
export type GetBondRedemptionListResponseDataItemType = typeof GetBondRedemptionListResponseDataItemType[keyof typeof GetBondRedemptionListResponseDataItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBondRedemptionListResponseDataItemType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  NONE: 'NONE',
} as const;
